/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
  aws_project_region: 'eu-west-1',
  aws_mobile_analytics_app_id: 'e4aaf69a3d39449d9339a608d286b9e6',
  aws_mobile_analytics_app_region: 'eu-west-1',
  Analytics: {
    AWSPinpoint: {
      appId: 'e4aaf69a3d39449d9339a608d286b9e6',
      region: 'eu-west-1'
    }
  },
  aws_cloud_logic_custom: [
    {
      name: 'exotics',
      endpoint: 'https://tdjvox4ibd.execute-api.eu-west-1.amazonaws.com/uat',
      region: 'eu-west-1'
    }
  ],
  aws_cognito_identity_pool_id:
    'eu-west-1:5f0d326b-ecc1-4d6e-9174-306eb5cb3f06',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_rXfXQtHZQ',
  aws_user_pools_web_client_id: '2am8ankcvtt58atlttuvhu8mdq',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL', 'PHONE_NUMBER'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_dynamodb_all_tables_region: 'eu-west-1',
  aws_dynamodb_table_schemas: [
    {
      tableName: 'config-uat',
      region: 'eu-west-1'
    },
    {
      tableName: 'historical-uat',
      region: 'eu-west-1'
    },
    {
      tableName: 'historical-daily-uat',
      region: 'eu-west-1'
    },
    {
      tableName: 'markets-uat',
      region: 'eu-west-1'
    },
    {
      tableName: 'strategies-uat',
      region: 'eu-west-1'
    },
    {
      tableName: 'trades-uat',
      region: 'eu-west-1'
    }
  ]
};
export default awsmobile;
